module.exports = __webpack_public_path__ + "home-bg-img2.ccc7121428f858d1a8f5.jpg";


//////////////////
// WEBPACK FOOTER
// C:/Users/pkwoy/Desktop/progressive-webb-app/src/assets/img/home-bg-img2.jpg
// module id = ../../../../../src/assets/img/home-bg-img2.jpg
// module chunks = styles